import { render, staticRenderFns } from "./CommentIcon.vue?vue&type=template&id=1215b615&"
import script from "./CommentIcon.vue?vue&type=script&lang=js&"
export * from "./CommentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports